"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./styles.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ThumbnailDot = function ThumbnailDotComponent(_ref) {
  var active = _ref.active,
      index = _ref.index,
      setViewedImageIndex = _ref.setViewedImageIndex,
      setSelectedImageindex = _ref.setSelectedImageindex;
  return /*#__PURE__*/_react["default"].createElement("button", {
    className: "product-details__carousel__dot".concat(active ? '--active' : ''),
    viewBox: "0 0 30 30",
    onMouseEnter: function onMouseEnter() {
      setViewedImageIndex(index);
    },
    onMouseLeave: function onMouseLeave() {
      setViewedImageIndex(null);
    },
    onClick: function onClick() {
      setSelectedImageindex(index);
    },
    onKeyPress: function onKeyPress() {
      setSelectedImageindex(index);
    },
    type: "button",
    tabIndex: 0
  });
};

ThumbnailDot.propTypes = {
  active: _propTypes["default"].bool.isRequired,
  index: _propTypes["default"].number.isRequired,
  setViewedImageIndex: _propTypes["default"].func.isRequired,
  setSelectedImageindex: _propTypes["default"].func.isRequired
};
var _default = ThumbnailDot;
exports["default"] = _default;